import {
  FaHome,
  FaClock,
  FaBookOpen,
  FaClipboardList,
  FaUniversity,
  FaTachometerAlt,
  FaListAlt,
  FaCalendarAlt,
  FaChalkboardTeacher,
  FaUser,
  FaUserCog,
  FaGraduationCap,
  FaCheckCircle,
  FaMarker,
  FaUsers,
  FaQuestion,
  FaNewspaper,
  FaRegBell,
  FaRegClipboard,
  FaKey,
  FaPaperPlane,
  FaList,
  FaComment,
  FaUserTie,
  FaMobileAlt,
  FaUserGraduate,
  FaLevelUpAlt,
  FaLink,
  FaChalkboard,
  FaStar,
  FaClipboardCheck,
  FaFileUpload,
  FaSync,
  FaFileAlt,
  FaCalendarCheck,
  FaTags,
  FaCheckDouble,
  FaUserClock,
  FaChartBar,
  FaBullhorn,
  FaFont,
  FaTable,
  FaScroll,
  FaDatabase,
  FaComments,
  FaUserShield,
  FaCogs,
  FaCalendarDay,
  FaUmbrellaBeach,
  FaHandPaper,
  FaWalking,
  FaLayerGroup,
  FaFileImport,
  FaFolder,
  FaUserFriends,
} from "react-icons/fa";
import "./TheLayout.css";

let allowedItems = [
  {
    permission: "dashboard.view",
    label: "Dashboard",
    _tag: "CSidebarNavItem",
    name: (
      <div className="sideBarNav">
        <FaHome />
        <span color="primary">Dashboard</span>
      </div>
    ),
    to: "/",
  },
  {
    permission: "school.management",
    label: "School Management",
    _tag: "CSidebarNavItem",
    name: (
      <div className="sideBarNav">
        <FaUniversity />
        <span>School Management</span>
      </div>
    ),
    to: "/organization/list",
    children: [
      {
        permission: "student.list.view",
        label: "Student List",
        _tag: "CSidebarNavItem",
        to: "/student/list",
        name: (
          <div className="sideBarNav">
            <FaUserGraduate />
            <span>Manage Student</span>
          </div>
        ),
      },
      {
        permission: "class.teacher.view",
        label: "Class Teacher",
        _tag: "CSidebarNavItem",
        to: "/class-teacher/list",
        name: (
          <div className="sideBarNav">
            <FaUserTie />
            <span>Manage Class Teacher</span>
          </div>
        ),
      },
      {
        permission: "student.promote",
        label: "Promote Students",
        _tag: "CSidebarNavItem",
        to: "/student/promote",
        name: (
          <div className="sideBarNav">
            <FaLevelUpAlt />
            <span>Promote Students</span>
          </div>
        ),
      },
      {
        permission: "student.subject.mapping.view",
        label: "Evaluation",
        _tag: "CSidebarNavItem",
        to: "/student/subject/mapping/list",
        name: (
          <div className="sideBarNav">
            <FaLink />
            <span>Student Subject Mapping</span>
          </div>
        ),
      },
      {
        permission: "teacher.subject.mapping.view",
        label: "Subject Teacher Mapping",
        _tag: "CSidebarNavItem",
        to: "/teacher/list",
        name: (
          <div className="sideBarNav">
            <FaChalkboardTeacher />
            <span>Subject Teacher Mapping</span>
          </div>
        ),
      },
      {
        permission: "teacher.time_table.view",
        label: "Subject Teacher Mapping",
        _tag: "CSidebarNavItem",
        to: "/teacher/timetable/list",
        name: (
          <div className="sideBarNav">
            <FaCalendarAlt />
            <span>Teacher TimeTable</span>
          </div>
        ),
      },
    ],
  },
  {
    permission: "academic.management",
    label: "Academic Management",
    _tag: "CSidebarNavItem",
    name: (
      <div className="sideBarNav">
        <FaGraduationCap />
        <span>Academic Management</span>
      </div>
    ),
    to: "/",
    children: [
      {
        permission: "sessions.view",
        label: "Sessions",
        _tag: "CSidebarNavItem",
        name: (
          <div className="sideBarNav">
            <FaClock />
            <span>Sessions</span>
          </div>
        ),
        to: "/session/list",
      },
      {
        permission: "schools.view",
        label: "Schools",
        _tag: "CSidebarNavItem",
        name: (
          <div className="sideBarNav">
            <FaUniversity />
            <span>Schools</span>
          </div>
        ),
        to: "/organization/list",
      },
      {
        permission: "class.view",
        _tag: "CSidebarNavItem",
        label: "Class",
        name: (
          <div className="sideBarNav">
            <FaChalkboard />
            <span>Class</span>
          </div>
        ),
        to: "/program/list",
      },
      {
        permission: "class.session.mapping.view",
        _tag: "CSidebarNavItem",
        label: "Class Session Mapping",
        name: (
          <div className="sideBarNav">
            <FaLink />
            <span>Class Session Mapping</span>
          </div>
        ),
        to: "/programs/session/mapping",
      },
      {
        permission: "subjects.view",
        _tag: "CSidebarNavItem",
        label: "Scholastic Subjects",
        name: (
          <div className="sideBarNav">
            <FaBookOpen />
            <span>Scholastic Subjects</span>
          </div>
        ),
        to: "/subject/list",
      },
      {
        permission: "traits.view",
        _tag: "CSidebarNavItem",
        label: "Co-Scholastic Subjects",
        name: (
          <div className="sideBarNav">
            <FaStar />
            <span>Co-Scholastic Subjects</span>
          </div>
        ),
        to: "/trait/list",
      },
      {
        permission: "homework.view",
        _tag: "CSidebarNavItem",
        label: "Homework",
        name: (
          <div className="sideBarNav">
            <FaRegClipboard />
            <span>Homework</span>
          </div>
        ),
        to: "/homework/list",
      },
      {
        permission: ["lesson_plan.view", "lesson_plan.view_all"],
        _tag: "CSidebarNavItem",
        label: "Lesson Planner",
        name: (
          <div className="sideBarNav">
            <FaBookOpen />
            <span>Lesson Planner</span>
          </div>
        ),
        to: "/lesson-planner",
      },
      {
        // Principal / coordinators who review and approve teachers' weekly diaries
        // (same permission as DIARY_PERMISSIONS.VIEW in pages/WeeklyDiary)
        permission: "weekly_diary.view",
        _tag: "CSidebarNavItem",
        label: "Weekly Diary",
        name: (
          <div className="sideBarNav">
            <FaCalendarAlt />
            <span>Weekly Diary</span>
          </div>
        ),
        to: "/weekly-diary",
      },
    ],
  },
  {
    permission: "exam.management",
    label: "Exams",
    _tag: "CSidebarNavItem",
    to: "/exam/list",
    name: (
      <div className="sideBarNav">
        <FaClipboardList />
        <span>Exam Management</span>
      </div>
    ),
    children: [
      {
        permission: "exam.config.view",
        label: "Exams",
        _tag: "CSidebarNavItem",
        to: "/exam/config/list",
        name: (
          <div className="sideBarNav">
            <FaCalendarAlt />
            <span>Exam Configuration</span>
          </div>
        ),
      },
      {
        permission: "exams.view",
        label: "Exams",
        _tag: "CSidebarNavItem",
        to: "/exam/list",
        name: (
          <div className="sideBarNav">
            <FaClipboardCheck />
            <span>Manage Exam</span>
          </div>
        ),
      },
      {
        permission: "assessment.marking.view",
        label: "Assessment Marking",
        _tag: "CSidebarNavItem",
        to: "/assessment/marking/list",
        name: (
          <div className="sideBarNav">
            <FaMarker />
            <span>Assessment Marking</span>
          </div>
        ),
      },
      {
        permission: "result.view",
        label: "Report Card",
        _tag: "CSidebarNavItem",
        to: "/report/card/manage",
        name: (
          <div className="sideBarNav">
            <FaGraduationCap />
            <span>Report Card</span>
          </div>
        ),
      },
      {
        permission: "publish.result.view",
        label: "Publish Result",
        _tag: "CSidebarNavItem",
        to: "/publish/result/list",
        name: (
          <div className="sideBarNav">
            <FaCheckCircle />
            <span>Publish Report Card</span>
          </div>
        ),
      },
      {
        permission: "result.view.json",
        label: "View Result",
        _tag: "CSidebarNavItem",
        to: "/result/view",
        name: (
          <div className="sideBarNav">
            <FaFileAlt />
            <span>View Result</span>
          </div>
        ),
      },
    ],
  },
  {
    permission: "result.analysis",
    label: "Result Analysis",
    _tag: "CSidebarNavItem",
    to: "/result/teacher-wise",
    name: (
      <div className="sideBarNav">
        <FaChartBar />
        <span>Result Analysis</span>
      </div>
    ),
    children: [
      {
        permission: "teacher.analysis",
        label: "Exams",
        _tag: "CSidebarNavItem",
        to: "/result/teacher-wise",
        name: (
          <div className="sideBarNav">
            <FaUserTie />
            <span>Teacher Wise Analysis</span>
          </div>
        ),
      },
      {
        permission: "teacher.analysis.class.wise",
        label: "Class Wise Analysis",
        _tag: "CSidebarNavItem",
        to: "/result/class-wise",
        name: (
          <div className="sideBarNav">
            <FaUsers />
            <span>Class Wise Analysis</span>
          </div>
        ),
      },
      {
        permission: "cbse.result.upload",
        label: "CBSE Result",
        _tag: "CSidebarNavItem",
        to: "/cbse/result/upload",
        name: (
          <div className="sideBarNav">
            <FaFileUpload />
            <span>CBSE Result</span>
          </div>
        ),
      },
    ],
  },
  {
    permission: "admin.management",
    label: "Admin Management",
    _tag: "CSidebarNavItem",
    name: (
      <div className="sideBarNav">
        <FaUserShield />
        <span>Admin Management</span>
      </div>
    ),
    to: "/template/list",
    children: [
      // {
      //   permission: "sync.student",
      //   label: "Sync Students",
      //   _tag: "CSidebarNavItem",
      //   to: "/student/sync",
      //   name: (
      //     <div className="sideBarNav">
      //       <FaSync />
      //       <span>Sync Students</span>
      //     </div>
      //   ),
      // },
      {
        permission: "template.view",
        label: "Template",
        _tag: "CSidebarNavItem",
        name: (
          <div className="sideBarNav">
            <FaFileAlt />
            <span>Template</span>
          </div>
        ),
        to: "/template/list",
      },
      {
        permission: "assessment.list.view",
        label: "Assessment",
        _tag: "CSidebarNavItem",
        to: "/assessment/list",
        name: (
          <div className="sideBarNav">
            <FaListAlt />
            <span>Assessment Listing</span>
          </div>
        ),
      },
      {
        permission: "scoreschemes.view",
        label: "Score Shemes",
        _tag: "CSidebarNavItem",
        to: "/score/schemes/list",
        name: (
          <div className="sideBarNav">
            <FaTachometerAlt />
            <span>Score Schemes</span>
          </div>
        ),
      },
      {
        permission: "evaluationtypes.view",
        label: "Evaluation",
        _tag: "CSidebarNavItem",
        to: "/evaluation/type/list",
        name: (
          <div className="sideBarNav">
            <FaLayerGroup />
            <span>Evaluation</span>
          </div>
        ),
      },
      {
        permission: "users.view",
        label: "User",
        _tag: "CSidebarNavItem",
        to: "/user/list",
        name: (
          <div className="sideBarNav">
            <FaUser />
            <span>Manage User</span>
          </div>
        ),
      },
      {
        permission: "role.view",
        label: "Role",
        _tag: "CSidebarNavItem",
        to: "/role/list",
        name: (
          <div className="sideBarNav">
            <FaUserCog />
            <span>Role</span>
          </div>
        ),
      },
    ],
  },
  {
    permission: "app.management",
    label: "App Management",
    _tag: "CSidebarNavItem",
    to: "/",
    name: (
      <div className="sideBarNav">
        <FaCogs />
        <span>App Management</span>
      </div>
    ),
    children: [
      {
        permission: "appointment.view",
        label: "Appointment",
        _tag: "CSidebarNavItem",
        to: "/appointment/list",
        name: (
          <div className="sideBarNav">
            <FaCalendarCheck />
            <span>Appointment</span>
          </div>
        ),
      },
      {
        permission: "meeting.with.type.view",
        label: "Meeting With Types",
        _tag: "CSidebarNavItem",
        to: "/meeting-with-types/list",
        name: (
          <div className="sideBarNav">
            <FaTags />
            <span>Meeting With Types</span>
          </div>
        ),
      },
      {
        permission: "parent.app.feature.view",
        label: "Parent App Features",
        _tag: "CSidebarNavItem",
        to: "/parent-app-features",
        name: (
          <div className="sideBarNav">
            <FaMobileAlt />
            <span>Parent App Features</span>
          </div>
        ),
      },
      {
        permission: "parent.request.approval",
        label: "Parent Request Approval",
        _tag: "CSidebarNavItem",
        to: "/parent-request-approval",
        name: (
          <div className="sideBarNav">
            <FaCheckDouble />
            <span>Parent Request Approval</span>
          </div>
        ),
      },
      {
        permission: "attendance.mapping",
        label: "Attendance",
        _tag: "CSidebarNavItem",
        to: "/attendance/teacher/mapping",
        name: (
          <div className="sideBarNav">
            <FaUserClock />
            <span>Attendance Teacher Map</span>
          </div>
        ),
      },
      {
        permission: "attendance.mapping",
        label: "Attendance",
        _tag: "CSidebarNavItem",
        to: "/attendance/dashboard",
        name: (
          <div className="sideBarNav">
            <FaChartBar />
            <span>Attendance Dashboard</span>
          </div>
        ),
      },
      {
        permission: "attendance.view",
        label: "Attendance",
        _tag: "CSidebarNavItem",
        to: "/attendance/list",
        name: (
          <div className="sideBarNav">
            <FaCalendarAlt />
            <span>Attendance</span>
          </div>
        ),
      },
      {
        permission: "activation.key.generate",
        label: "Generate Activation Key",
        _tag: "CSidebarNavItem",
        to: "/generate/activation/key",
        name: (
          <div className="sideBarNav">
            <FaKey />
            <span>Generate Activation Key</span>
          </div>
        ),
      },
      {
        permission: "leave.view",
        label: "Leave",
        _tag: "CSidebarNavItem",
        to: "/leave/list",
        name: (
          <div className="sideBarNav">
            <FaUmbrellaBeach />
            <span>Leave</span>
          </div>
        ),
      },
      {
        permission: "circular.view",
        label: "Circular",
        _tag: "CSidebarNavItem",
        to: "/circular/list",
        name: (
          <div className="sideBarNav">
            <FaBullhorn />
            <span>Circular</span>
          </div>
        ),
      },
      {
        permission: "word_of_the_day.view",
        label: "Word Of The Day",
        _tag: "CSidebarNavItem",
        to: "/word-of-the-day",
        name: (
          <div className="sideBarNav">
            <FaFont />
            <span>Word of The Day</span>
          </div>
        ),
      },
      {
        permission: "event.calendar.view",
        label: "Event",
        _tag: "CSidebarNavItem",
        to: "/event/list",
        name: (
          <div className="sideBarNav">
            <FaCalendarDay />
            <span>Event</span>
          </div>
        ),
      },
      {
        permission: "time_table.view",
        label: "Time Table",
        _tag: "CSidebarNavItem",
        to: "/upload/timetable/list",
        name: (
          <div className="sideBarNav">
            <FaTable />
            <span>Time Table</span>
          </div>
        ),
      },
      {
        permission: "syllabus.view",
        label: "Syllabus",
        _tag: "CSidebarNavItem",
        to: "/syllabus/list",
        name: (
          <div className="sideBarNav">
            <FaScroll />
            <span>Syllabus</span>
          </div>
        ),
      },
      {
        permission: "notification.view",
        label: "Notifiaction",
        _tag: "CSidebarNavItem",
        to: "/notification/list",
        name: (
          <div className="sideBarNav">
            <FaRegBell />
            <span>Notification</span>
          </div>
        ),
      },
      {
        permission: "news_letter.view",
        label: "NewsLetter",
        _tag: "CSidebarNavItem",
        to: "/newsletter/list",
        name: (
          <div className="sideBarNav">
            <FaNewspaper />
            <span>News Letter</span>
          </div>
        ),
      },
      {
        permission: "faq.view",
        label: "FAQ",
        _tag: "CSidebarNavItem",
        to: "/faq",
        name: (
          <div className="sideBarNav">
            <FaQuestion />
            <span>FAQ</span>
          </div>
        ),
      },
    ],
  },
  // {
  //   permission: "daily.school.life",
  //   label: "App Management",
  //   _tag: "CSidebarNavItem",
  //   to: "/",
  //   name: (
  //     <div className="sideBarNav">
  //       <FaCalendarDay />
  //       <span>Daily School Life</span>
  //     </div>
  //   ),
  //   children: [
  //     {
  //       permission: "teacher.circular.view",
  //       label: "Circular",
  //       _tag: "CSidebarNavItem",
  //       to: "/teacher/view/circular",
  //       name: (
  //         <div className="sideBarNav">
  //           <FaBullhorn />
  //           <span>Circular</span>
  //         </div>
  //       ),
  //     },
  //     {
  //       permission: "teacher.word_of_the_day.view",
  //       label: "Word Of The Day",
  //       _tag: "CSidebarNavItem",
  //       to: "/teacher/view/word-of-the-day",
  //       name: (
  //         <div className="sideBarNav">
  //           <FaFont />
  //           <span>Word of The Day</span>
  //         </div>
  //       ),
  //     },
  //     {
  //       permission: "teacher.time_table.view",
  //       label: "Time Table",
  //       _tag: "CSidebarNavItem",
  //       to: "/teacher/view/timetable",
  //       name: (
  //         <div className="sideBarNav">
  //           <FaTable />
  //           <span>Time Table</span>
  //         </div>
  //       ),
  //     },
  //     {
  //       permission: "teacher.syllabus.view",
  //       label: "Syllabus",
  //       _tag: "CSidebarNavItem",
  //       to: "/teacher/view/syllabus",
  //       name: (
  //         <div className="sideBarNav">
  //           <FaScroll />
  //           <span>Syllabus</span>
  //         </div>
  //       ),
  //     },
  //     {
  //       permission: "teacher.notification.view",
  //       label: "Notifiaction",
  //       _tag: "CSidebarNavItem",
  //       to: "/teacher/view/notification",
  //       name: (
  //         <div className="sideBarNav">
  //           <FaRegBell />
  //           <span>Notifiaction</span>
  //         </div>
  //       ),
  //     },
  //     {
  //       permission: "teacher.news_letter.view",
  //       label: "NewsLetter",
  //       _tag: "CSidebarNavItem",
  //       to: "/teacher/view/newsletter",
  //       name: (
  //         <div className="sideBarNav">
  //           <FaNewspaper />
  //           <span>News Letter</span>
  //         </div>
  //       ),
  //     }
  //   ]
  // },
  // {
  //   permission: "query.view",
  //   label: "App Management",
  //   _tag: "CSidebarNavItem",
  //   to: "/",
  //   name: (
  //     <div className="sideBarNav">
  //       <FaHandPaper />
  //       <span className="mx-2">Queries</span>
  //     </div>
  //   ),
  //   children: [
  //     {
  //       permission: "query.category.view",
  //       label: "Queries",
  //       _tag: "CSidebarNavItem",
  //       to: "/query/category/list",
  //       name: (
  //         <div className="sideBarNav">
  //           <FaList />
  //           <span>Query Categories</span>
  //         </div>
  //       ),
  //     },
  //     {
  //       permission: "query.view",
  //       label: "Queries",
  //       _tag: "CSidebarNavItem",
  //       to: "/queries",
  //       name: (
  //         <div className="sideBarNav">
  //           <FaPaperPlane />
  //           <span>Queries</span>
  //         </div>
  //       ),
  //     },
  //     {
  //       permission: "visitor.view",
  //       label: "Visitor",
  //       _tag: "CSidebarNavItem",
  //       to: "/visitors",
  //       name: (
  //         <div className="sideBarNav">
  //           <FaWalking />
  //           <span>Visitor</span>
  //         </div>
  //       ),
  //     },
  //   ]
  // },
  // {
  //   permission: "visitor.view",
  //   label: "Visitor",
  //   _tag: "CSidebarNavItem",
  //   to: "/",
  //   name: (
  //     <div className="sideBarNav">
  //       <FaWalking />
  //       <span className="mx-2">Visitor</span>
  //     </div>
  //   ),
  //   children: [
  //     {
  //       permission: "visitor.view",
  //       label: "Visitor",
  //       _tag: "CSidebarNavItem",
  //       to: "/visitors",
  //       name: (
  //         <div className="sideBarNav">
  //           <FaWalking />
  //           <span>Visitor</span>
  //         </div>
  //       ),
  //     },
  //   ]
  // },
  {
    permission: "session.management",
    label: "Session Management",
    _tag: "CSidebarNavItem",
    to: "/",
    name: (
      <div className="sideBarNav">
        <FaClock />
        <span className="">Session Management</span>
      </div>
    ),
    children: [
      {
        permission: "session.management",
        label: "Queries",
        _tag: "CSidebarNavItem",
        to: "/sync-data/with-data-lake",
        name: (
          <div className="sideBarNav">
            <FaDatabase />
            <span>Session Management</span>
          </div>
        ),
      },
    ],
  },
  {
    permission: "stakeholder.query.view",
    label: "Feedback Management",
    _tag: "CSidebarNavItem",
    to: "/stackholder-query/list",
    name: (
      <div className="sideBarNav">
        <FaComment />
        <span className="mx-1">Feedback Management</span>
      </div>
    ),
    children: [
      {
        permission: "stakeholder.request.type.view",
        label: "Queries",
        _tag: "CSidebarNavItem",
        to: "/stakeholder-request-type/list",
        name: (
          <div className="sideBarNav">
            <FaTags />
            <span>Request Types</span>
          </div>
        ),
      },
      {
        permission: "stakeholder.query.view",
        label: "Queries",
        _tag: "CSidebarNavItem",
        to: "/stakeholder-query/list",
        name: (
          <div className="sideBarNav">
            <FaComments />
            <span>Feedback Management</span>
          </div>
        ),
      },
    ],
  },
  {
    permission: "survey.view",
    label: "Surveys",
    _tag: "CSidebarNavItem",
    to: "/surveys",
    name: (
      <div className="sideBarNav">
        <FaClipboardList />
        <span className="mx-1">Surveys</span>
      </div>
    ),
    children: [
      {
        permission: "survey.view",
        label: "Surveys",
        _tag: "CSidebarNavItem",
        to: "/surveys",
        name: (
          <div className="sideBarNav">
            <FaClipboardList />
            <span>Surveys</span>
          </div>
        ),
      },
      {
        permission: "survey.create",
        label: "Import Survey",
        _tag: "CSidebarNavItem",
        to: "/import/survey",
        name: (
          <div className="sideBarNav">
            <FaFileImport />
            <span>Import Survey</span>
          </div>
        ),
      },
      {
        permission: "survey.view",
        label: "Folders",
        _tag: "CSidebarNavItem",
        to: "/folder",
        name: (
          <div className="sideBarNav">
            <FaFolder />
            <span>Folders</span>
          </div>
        ),
      },
    ],
  },
];

const permissions = JSON.parse(localStorage.getItem("permissions"));

// `permission` may be a single name or a list (any one of them is enough)
const isAllowed = (permission) =>
  Boolean(permissions) &&
  (Array.isArray(permission)
    ? permission.some((name) => permissions.includes(name))
    : permissions.includes(permission));

const nav =
  allowedItems &&
  allowedItems.filter((item) => {
    if (item.children) {
      item.children = item.children.filter((child) => isAllowed(child.permission));
    }
    return isAllowed(item.permission);
  });

export const navigation = nav;
